import React, { useState, ChangeEvent } from 'react';
import HelloSignPreview from '../components/HelloSignPreview';
import { hellosignApi } from '../api';

const DocumentPreviewPage: React.FC = () => {
  const [signatureRequestId, setSignatureRequestId] = useState('');
  const [previewId, setPreviewId] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!signatureRequestId) {
      setError('Please enter a signature request ID');
      return;
    }
    
    setError('');
    setSuccess('');
    setPreviewId(signatureRequestId);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSignatureRequestId(e.target.value);
  };

  const handleDelete = async () => {
    if (!previewId) return;
    
    try {
      setIsDeleting(true);
      setError('');
      setSuccess('');
      
      // Delete the document using the API
      await hellosignApi.deleteDocument(previewId);
      
      setSuccess(`Document ${previewId} deleted successfully`);
      setPreviewId(''); // Clear the preview
    } catch (err) {
      setError(`Failed to delete document: ${err instanceof Error ? err.message : 'Unknown error'}`);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="container mx-auto py-5 px-4">
      <h1 className="text-2xl font-bold mb-4">HelloSign Document Preview</h1>
      
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-3">
          <label htmlFor="signature-id" className="block text-gray-700 mb-2">
            Signature Request ID
          </label>
          <input
            id="signature-id"
            type="text"
            value={signatureRequestId}
            onChange={handleChange}
            placeholder="Enter the HelloSign signature request ID"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        
        {error && (
          <div className="bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        {success && (
          <div className="bg-green-50 border border-green-300 text-green-700 px-4 py-3 rounded mb-4">
            {success}
          </div>
        )}
        
        <button 
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-2"
        >
          Preview Document
        </button>
      </form>
      
      {previewId && (
        <div className="mt-4">
          <div className="flex justify-between items-center mb-3">
            <h2 className="text-xl font-semibold">Document Preview</h2>
            <button 
              onClick={handleDelete}
              disabled={isDeleting}
              className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {isDeleting ? 'Deleting...' : 'Delete Document'}
            </button>
          </div>
          <div className="border rounded">
            <HelloSignPreview signatureRequestId={previewId} height="800px" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentPreviewPage; 